import { render, staticRenderFns } from "./headersL.vue?vue&type=template&id=b0daf6d8&scoped=true&"
import script from "./headersL.vue?vue&type=script&lang=js&"
export * from "./headersL.vue?vue&type=script&lang=js&"
import style0 from "./headersL.vue?vue&type=style&index=0&id=b0daf6d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0daf6d8",
  null
  
)

export default component.exports